module.exports = __webpack_public_path__ + "5a9afdf6e4fbbdaf0b35b3bb7d2f9241.png";